<template>
  <div class="header">
    <NavBar />
    <div class="title-header">
      <h1 class="title">{{ title }}</h1>
      <p class="subtitle">{{ subtitle }}</p>
    </div>
    <div class="contributors">
      <div class="author">
        <p>author</p>
        <p>{{ author }}</p>
      </div>
      <div class="supervisor">
        <p>supervisor</p>
        <p>{{ supervisor }}</p>
      </div>
    </div>
    <img class="pgel-logo" :src="`${publicPath}header-background.svg`" />
  </div>
</template>

<script>
import NavBar from './NavBar.vue';
export default {
  name: 'header',
  components: {
    NavBar
  },
  props: {
    title: String,
    subtitle: String,
    author: String,
    supervisor: String
  },
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-height: 100vh;
  width: 100%;

  text-align: right;
}

.pgel-logo {
  position: absolute;
  top: 15%;
  align-self: flex-start;
  height: 15em;
  margin: 10em;
}
.title-header {
  align-self: flex-end;
  width: 60%;
}
.title {
  font-size: 4rem;
  margin: 2rem;
}

.subtitle {
  font-size: 2rem;
  margin-left: 2rem;
  margin-right: 2rem;
}

.contributors {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 2rem;
  margin-right: 2rem;
  font-size: 1.5rem;
  color: #e7755f;

  * {
    margin: 0.25vw;
  }
}

@media (max-width: 1200px) {
  .pgel-logo {
    height: 12.5em;
    margin: 8em;
  }
}

@media (max-width: 1080px) {
  .pgel-logo {
    display: none;
  }
  .title-header {
    margin-top: 7em;
    width: 75%;
  }
}

@media (max-width: 725px) {
  .title {
    font-size: 3rem;
  }

  .subtitle {
    font-size: 2rem;
  }
}

@media (max-width: 550px) {
  .title-header {
    width: 100%;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1.5rem;
  }
}
</style>
